// extracted by mini-css-extract-plugin
module.exports = {"container_spin":"Spinner_container_spin__1vDVb","spin":"Spinner_spin__18Ltq","spinning":"Spinner_spinning__2Xsyi"};